import { useCallback, useEffect, useState } from "react";
import { localDayKey, nextDayDelay } from "@/lib/dashboard-day";

// One local timeout at midnight; no network requests or repeating interval.
export function useDashboardDay() {
  const [day, setDay] = useState(() => localDayKey());
  const refreshDay = useCallback(() => setDay(localDayKey()), []);
  useEffect(() => {
    let timeout: number | undefined;
    const check = () => {
      window.clearTimeout(timeout);
      if (document.hidden) return;
      refreshDay();
      timeout = window.setTimeout(check, nextDayDelay());
    };
    check();
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", check);
    return () => {
      window.clearTimeout(timeout);
      window.removeEventListener("focus", check);
      document.removeEventListener("visibilitychange", check);
    };
  }, [refreshDay]);
  return { day, refreshDay };
}
